import { useMutation } from '@tanstack/react-query';
import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/index.ts';
import { OnboardingFlowIdentifier } from '@Types/onboarding.types';
import type { RegionCode } from 'google-libphonenumber';

export interface StartAuthorizedUserOnboardingRequest {
  phoneNumber?: string;
  phoneNumberCountryCode?: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
}

export interface StartAuthorizedUserOnboardingResponse {
  mfaDestination?: string;
  mfaType?: string;
  customerId?: string;
  authorizedUserFullName?: string;
  authorizedExternalId?: string;
  hasPassword?: boolean;
}

export const startAuthorizedUserOnboarding = async (data: StartAuthorizedUserOnboardingRequest) => {
  const { customerId, authorizedUserId } = useBoundStore.getState().onboardingSlice;
  const response = await HttpService.post<StartAuthorizedUserOnboardingResponse>(
    `v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/start`,
    data
  );
  return response.data;
};

export const useStartAuthorizedUserOnboarding = () =>
  useMutation({
    mutationFn: (data: StartAuthorizedUserOnboardingRequest) => startAuthorizedUserOnboarding(data),
  });

export const updatePhoneNumber = async (phoneNumber: string, isoCode: RegionCode) => {
  const { customerId } = useBoundStore.getState().customer;
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const {
    onboardingFlowIdentifier,
    authorizedUserId,
    customerId: authUserCustomerId,
  } = useBoundStore.getState().onboardingSlice.getOnboardingData();

  let url: string;
  if (onboardingFlowIdentifier === OnboardingFlowIdentifier.AUTHORIZED_USER) {
    url = `v3/onboarding/user/${authUserCustomerId}/authorized/user/${authorizedUserId}/phone`;
  } else if (isEmbedded) {
    url = `v3/secureonboarding/partner/user/${customerId}/phone/`;
  } else {
    url = `v3/secureonboarding/user/${customerId}/phone/`;
  }

  await HttpService.post(url, {
    phoneNumber,
    phoneNumberCountryCode: isoCode,
  });
  return phoneNumber;
};
